import React from 'react';
import Grid from '../../common/Grid/Grid';
import FeedbackAssignmentCard from './FeedbackAssignmentCard';

const FeedbackResultsGrid = ({
  assignments,
  isLoading,
  isLoadingMore,
  pageInfo,
  handleItemClick,
  handleGridScroll,
  showLoadingSpinner,
  shouldHideContent,
  loadMoreData,
  gridRef,
  onViewReport,
  selectable,
  selectedIds,
  onSelectionChange,
}) => {
  // Custom renderer for feedback assignment items
  // Selection props are passed via extraItemData to avoid key changes that reset scroll
  const renderFeedbackItem = ({ item, selectable: selectableProp, selectedIds: selectedIdsProp, onSelectionChange: onSelectionChangeProp, onViewReport: onViewReportProp }) => {
    const isSelected = selectedIdsProp?.includes(item.id) || false;
    return (
      <FeedbackAssignmentCard
        assignment={item}
        onViewReport={onViewReportProp}
        selectable={selectableProp}
        isSelected={isSelected}
        onSelectionChange={onSelectionChangeProp}
        selectedIds={selectedIdsProp || []}
      />
    );
  };

  return (
    <Grid
      items={assignments}
      isLoading={isLoading}
      isLoadingMore={isLoadingMore}
      pageInfo={pageInfo}
      renderItem={renderFeedbackItem}
      handleItemClick={handleItemClick}
      handleGridScroll={handleGridScroll}
      showLoadingSpinner={showLoadingSpinner}
      shouldHideContent={shouldHideContent}
      loadMoreData={loadMoreData}
      gridRef={gridRef}
      emptyStateTitle="No Feedback Assignments Found"
      emptyStateDescription="No assignments found matching the current search criteria. Try adjusting your filters."
      endOfListMessage="You've reached the end of the list"
      rowHeight={580}
      extraItemData={{
        selectable,
        selectedIds,
        onSelectionChange,
        onViewReport
      }}
    />
  );
};

export default FeedbackResultsGrid;
